<app-sidebar-filters></app-sidebar-filters>

@if (viewModel$ | async; as vm) {
  <ng-container *ngIf="vm.showModeControlCard">
    <app-sidebar-control-mode-card></app-sidebar-control-mode-card>
  </ng-container>

  <ng-container *ngIf="vm.showHomeCard">
    <app-sidebar-home-card></app-sidebar-home-card>
  </ng-container>
}

<app-sidebar-rooms></app-sidebar-rooms>
